// extracted by mini-css-extract-plugin
export default {"note":"chatNote_note__o558C","loader":"chatNote_loader__aYt7G","l1":"chatNote_l1__Hv-qh"};